import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const MultiYachtViewPage = withSuspense(
	lazy(async () => await import('./multi-yacht-view-page.component')),
	PageLoader,
);
